function MeetingEnded() {
  return <div>Meeting Ended</div>;
}

export default MeetingEnded;
